/**
 * SOLID Review
 * S — Strong. One concern: the browser's window and document behind the page-events role.
 * O — Good. A new event of the window's is nothing here; of the document's, one more case.
 * L — Strong. Implements `IServiceWindowEvents` exactly.
 * I — Strong. Two operations.
 * D — Strong. The window and the document are handed in, as suppliers.
 */
import type { IServiceWindowEvents, TPageEvent } from './IServiceWindowEvents';

/**
 * THE PAGE'S ATTENTION, FROM THE BROWSER (frontend-infrastructure-oo P2, 2026-10-28, §28.287): `visibilitychange` and the
 * visibility state from the document, every other event from the window — each reached through the supplier the composition
 * root hands it (`() => window`), so nothing here names a global.
 */
export class BrowserWindowEvents implements IServiceWindowEvents {
  constructor(
    private readonly window: () => Pick<Window, 'addEventListener'>,
    private readonly document: () => Pick<Document, 'addEventListener' | 'visibilityState'>,
  ) {}

  on(event: TPageEvent, listener: () => void): void {
    if (event === 'visibilitychange') this.document().addEventListener(event, listener);
    else this.window().addEventListener(event, listener);
  }

  isVisible(): boolean {
    return this.document().visibilityState === 'visible';
  }
}
